import { UploadArtwork } from "@design-lab/widgets/design-lab-upload-artwork";
import { WeaveDesignLab } from "@design-lab/features/weave-design-lab";
import { useShowWeaveDesignLab, useExperiments } from "@design-lab/shared/lib/config";
import { shouldReorderDesignLabTabs } from "@design-lab/shared/lib/experiments";
import { FrontBackSubTabs } from "./FrontBackSubTabs";

/**
 * Reusable component that conditionally renders WeaveDesignLab or UploadArtwork
 * based on the shouldShowWeaveDesignLab experiment.
 * When ab_design_lab_reorder_tabs experiment is enabled, shows Front/Back sub-tabs.
 */
export function UploadSection() {
  const shouldShowWeaveDesignLab = useShowWeaveDesignLab();
  const experiments = useExperiments();
  const showSubTabs = shouldReorderDesignLabTabs(experiments?.abDesignLabReorderTabs);

  if (shouldShowWeaveDesignLab) {
    return <WeaveDesignLab />;
  }

  // A/B Test Variant: Show sub-tabs for Front/Back
  if (showSubTabs) {
    return (
      <FrontBackSubTabs
        title="Upload"
        number={1}
        testIdPrefix="upload"
        frontContent={<UploadArtwork side="front" />}
        backContent={<UploadArtwork side="back" />}
      />
    );
  }

  // Control: Original behavior without sub-tabs
  return <UploadArtwork />;
}
